import React, {Component} from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    Button,
    Container
} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import logo from '../../assets/images/us-logo-sort.png';

class Header extends Component {
    constructor(props){
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        }
    }
    toggle(){
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    render() {
        return(
            <div>
                <Navbar color="light" light expand="lg">
                    <Container>
                        <NavLink to='/' exact className='navbar-brand'><img src={logo} alt="Ungdomssamfundet Logo"/></NavLink>
                        <NavbarToggler onClick={this.toggle} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <NavLink exact to="/">Hjem</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink to="/apningstider">Åpningstider</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink to="/kontakt">Kontakt Oss</NavLink>
                                </NavItem>
                                <NavItem className='support-us-button-menu'>
                                    <Button color="success" size="sm"><NavLink to="/stott-oss">Støtt oss</NavLink></Button>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </Container>
                </Navbar>
            </div>
        )
    }

}



export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js